import { useCallback, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

export const useRedirectPath = () => {
  const navigate = useNavigate();
  const hasRedirected = useRef(false);

  const getRedirectPath = useCallback(() => {
    return new URLSearchParams(window.location.search).get('redirect');
  }, []);

  const navigateToApp = useCallback(() => {
    navigate(getRedirectPath() || '/stores');
  }, [getRedirectPath, navigate]);

  const navigateToStoreSelection = useCallback(() => {
    navigate('/stores');
  }, [navigate]);

  const navigateToLogin = useCallback(() => {
    if (hasRedirected.current) {
      return;
    }

    const redirect = window.location.pathname + window.location.search;
    navigate('/login?redirect=' + redirect);
    hasRedirected.current = true;
  }, [navigate]);

  const navigateToLoginAfterLogout = useCallback(() => {
    window.location.href = '/login';
  }, []);

  return {
    navigateToApp,
    navigateToLogin,
    navigateToStoreSelection,
    navigateToLoginAfterLogout,
  };
};
